import './index.less';

import { MenuProps } from 'antd';
import _ from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AVAILABLE_LANGS, LANGUAGE_KEY } from '@/constants';

import iconEn from './assets/icon_lang_en.svg?url';
import iconEs from './assets/icon_lang_es.svg?url';
import iconFr from './assets/icon_lang_fr.svg?url';
import iconJp from './assets/icon_lang_jp.svg?url';
// import iconKr from './assets/icon_lang_kr.svg?react';
import classNames from 'classnames';
import Dropdown from '../Dropdown';
import IconLanguage from './assets/icon-nav-language.svg?react';
import iconTh from './assets/icon_lang_th.svg?url';
import iconTr from './assets/icon_lang_tr.svg?url';
import iconVi from './assets/icon_lang_vn.svg?url';

export function useLangConfigs(): {
  [key: string]: { src: string; name: string; enName: string; enShortName: string };
} {
  const langIconMap = useMemo(
    () => ({
      [AVAILABLE_LANGS.ENGLISH]: { src: iconEn, name: 'English', enName: 'ENGLISH', enShortName: 'en' },
      [AVAILABLE_LANGS.TURKEY]: { src: iconTr, name: 'Türkçe', enName: 'TURKEY', enShortName: 'tr' },
      // [AVAILABLE_LANGS.KOREAN]: { src: iconKr, name: '한국어', enName: 'VIETNAMESE', enShortName: 'kr' },
      [AVAILABLE_LANGS.VIETNAMESE]: { src: iconVi, name: 'Tiếng Việt', enName: 'KOREAN', enShortName: 'vi' },
      [AVAILABLE_LANGS.Spanish]: { src: iconEs, name: 'Español', enName: 'Spanish', enShortName: 'es' },
      [AVAILABLE_LANGS.French]: { src: iconFr, name: 'Français', enName: 'French', enShortName: 'fr' },
      [AVAILABLE_LANGS.Japanese]: { src: iconJp, name: '日本語', enName: 'Japanese', enShortName: 'ja' },
      [AVAILABLE_LANGS.Thai]: { src: iconTh, name: 'ภาษาไทย', enName: 'Thai', enShortName: 'th' },
    }),
    [],
  );
  return langIconMap;
}

function LanguageSelector(): JSX.Element | null {
  const { i18n } = useTranslation();
  const langConfigs = useLangConfigs();
  const [selectedKey, setSelectedKey] = useState(AVAILABLE_LANGS.ENGLISH);
  const dropdownOptions: MenuProps['items'] = useMemo(
    () =>
      _.values(langConfigs).map((langConfig, i: number) => {
        const langItem = langConfig;
        return {
          label: (
            <div className={classNames('syn-lang-item', { selected: selectedKey === langItem.enShortName })} key={i}>
              {langItem && <img loading="lazy" src={langItem.src} className="syn-language-img" alt="Select Language" />}
              <div className="syn-language-label">{langItem.name}</div>
            </div>
          ),
          key: langConfig.enShortName,
        };
      }),
    [langConfigs, selectedKey],
  );
  const selectLang = useCallback(
    async (lang: string) => {
      await i18n.changeLanguage(lang);
      localStorage.setItem(LANGUAGE_KEY, lang);
      setSelectedKey(lang as AVAILABLE_LANGS);
    },
    [i18n],
  );
  useEffect(() => {
    setSelectedKey((localStorage.getItem(LANGUAGE_KEY) as AVAILABLE_LANGS) || AVAILABLE_LANGS.ENGLISH);
  }, []);

  return (
    <>
      <Dropdown
        className={'syn-language-select'}
        overlayClassName="syn-language__dropdown"
        placement="bottomRight"
        align={{ offset: [0, 20] }}
        menu={{
          items: dropdownOptions,
          onClick: (info: { key: string }) => {
            selectLang(info.key);
          },
        }}>
        <div className="syn-lang-item-selected">
          <IconLanguage />
        </div>
      </Dropdown>
    </>
  );
}

export default LanguageSelector;
